import React from 'react'

import { ROUTING_MEASURES } from 'cube/constants'
import { isNil } from 'ramda'

import { Link, Text } from '@driftt/dds'
import { CubeQueryStringAdapter } from '@driftt/dds.reports'

import { useTrackDrillDownClickEvent } from 'components/conversation/hooks/useTrackDrilldownClickEvent'
import { ReportKPICard } from 'components/KPICard'
import { useRoutingReportDrillDownQuery } from 'components/routing/RoutingReportDrillDown/hooks'
import { CONVO_DETAIL_REPORT_PATH } from 'layouts/ConversationsDetailReport/ConversationsDetailReport.constants'
import { TypeFormats } from 'utils/format'

import { RESPONSE_RATE_RANGE_DESCRIPTION } from './ResponseRate.constants'
import useResponseRate from './useResponseRate.hook'

export const ResponseRate = () => {
  const {
    score,
    metric,
    isLoading,
    isError,
    hasNoData,
    totalRecords,
    totalRequests,
  } = useResponseRate()
  const { drillDownCubeQuery } = useRoutingReportDrillDownQuery(
    ROUTING_MEASURES.TEAMMATE_ROUTED_IN_TO_RESPONDED_WITHIN60S
  )

  const { trackViewEvent } = useTrackDrillDownClickEvent(
    'RoutingResponseRateChatsKPICard'
  )

  const drillDownQueryString =
    CubeQueryStringAdapter.toQueryString(drillDownCubeQuery)

  return (
    <ReportKPICard
      title="Response rate"
      isLoading={isLoading}
      isError={isError}
      hasNoData={hasNoData}
      subtitle="When routed to a teammate, how many chats were responded to within 60s?"
      score={score}
      metric={metric}
      metricRange={RESPONSE_RATE_RANGE_DESCRIPTION}
      formatMetric={(responseRate: number) => TypeFormats.PERCENT(responseRate)}
    >
      {!isNil(totalRequests) && !isNil(totalRecords) && (
        <Text variant="metadata">
          {totalRecords.toLocaleString()} out of{' '}
          {totalRequests.toLocaleString()} routed chats
        </Text>
      )}
      {!!totalRecords && (
        <Link
          target="_blank"
          variant="inline"
          href={`${CONVO_DETAIL_REPORT_PATH}?${drillDownQueryString}`}
          onClick={() => trackViewEvent({ totalRecords: metric ?? 0 })}
        >
          View data
        </Link>
      )}
    </ReportKPICard>
  )
}
